import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "@/hooks/useAuthentication";
import { useSelector } from "react-redux";
import { getUserData } from "@/redux/slices/userSlices";

const ProtectedLogin = ({ props }: React.ReactElement) => {
  const isAuthed: boolean = useAuth();
  const user = useSelector(getUserData);
  return isAuthed ? (
    user.is_change_pass ? (
      <Navigate to={"/Manage/ChangePassword"} />
    ) : (
      <Navigate to={"/Manage"} replace />
    )
  ) : (
    props
  );
};

export default ProtectedLogin;
